module.exports = __webpack_public_path__ + "img/fyt_p22.0787fb45.png";